import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import { TranslocoModule, translate } from '@jsverse/transloco';
import { SourcePlatform } from 'graphql/generated';
import { OTPForm } from '@app/core/types/authentication-form.type';
import { AuthService } from '@app/core/services/auth.service';
import { FormPinComponent } from '@app/core/components/forms/pin/form-pin.component';

@Component({
  standalone: true,
  selector: 'ups-verification-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auth-verification-modal.component.html',
  styleUrls: ['./../login/auth-login-modal.component.scss'],
  imports: [
    ReactiveFormsModule,
    IonicModule,
    TranslocoModule,
    FormPinComponent,
  ]
})
export class VerificationModalComponent implements OnInit, OnDestroy {
  
  @Input() public phone!: string;
  @ViewChild('btn') protected btn!: ElementRef;
  public readonly form: FormGroup<OTPForm> = new FormGroup({
    otp: new FormControl('', { nonNullable: true, validators: [ Validators.required, Validators.minLength(6) ] })
  });
  public second: number = 0;
  protected interval: any;
  protected sub?: Subscription;

  constructor(
    protected readonly ch: ChangeDetectorRef,
    protected readonly authService: AuthService,
    protected readonly modalCtrl: ModalController,
    protected readonly alertCtrl: AlertController,
  ) { }

  public ngOnInit(): void{
    this.resend();
    history.pushState({ verif: true }, '');
  }

  public ngOnDestroy(): void{
    if (history.state.verif) history.back();
    this.sub?.unsubscribe();
  }

  @HostListener('window:popstate')
  public back(auto: boolean = false): void{ this.modalCtrl.dismiss({ auto }); }

  public resend(): void{
    if (this.second === 0) {
      this.second = 60;
      this.interval = setInterval(() => {
        this.second--;
        
        if (this.second === 0) clearInterval(this.interval);
        this.ch.markForCheck();
      }, 1000);

      this.sendOtp();
    }
  }

  public verify(): void{
    if (!this.form.valid) return;

    this.toggleBtn();
    this.sub?.unsubscribe();
    this.sub = this.authService.confirmVerification({ code: this.form.value.otp!, mobileNumber: this.phone, sourcePlatform: SourcePlatform.CpCommerce }).subscribe({
      next: () => this.back(true),
      error: ({ message }) => {
        this.toggleBtn();
        this.showAlert(message);
      }
    });
  }

  protected toggleBtn(): void{
    this.btn?.nativeElement.toggleAttribute('disabled');
    this.btn?.nativeElement.classList.toggle('btn-loading');
  }

  protected sendOtp(): void{
    this.authService.resendVerification(this.phone, 'mobileNumber').subscribe({
      next: ({ data: { authMsResendMobileVerif }}: any) => this.showAlert(authMsResendMobileVerif, translate('title.success')),
      error: ({ message }: any) => this.showAlert(message)
    });
  }

  protected async showAlert(message: string = translate('message.try_again'), header: string = translate('title.error')): Promise<void>{ (await this.alertCtrl.create({ header, message, buttons: [{ text:'OK' }] })).present(); }
}
